/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { ButtonPrimary } from '../../../../../../utils/Button';
import cn from '../../../../../../utils/cn';

const billingCycle = [
    { key: 1, value: 'monthly' },
    { key: 3, value: 'quarterly' },
    { key: 6, value: 'half-yearly' },
    { key: 12, value: 'yearly' }
];

function TableInfoCard({ show = true, name, value, isCapitalize, className }) {
    if (!show) {
        return null;
    }
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item, isDuration, isLifetime, handleDelete, openModal }) {
    const [isActive, setIsActive] = useState(false);

    const handleOpenModal = (ev) => {
        ev.stopPropagation();
        openModal('package-pricing', item);
    };

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1 uppercase">{item?.currency}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            item?.status === 'active' ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    show={isDuration && !isLifetime}
                    name="Billing Cycle"
                    value={
                        <span className="capitalize">
                            {billingCycle?.find(({ key }) => key === item?.limitByValue)?.value}
                        </span>
                    }
                />
                <TableInfoCard
                    show={!isDuration && !isLifetime}
                    name="PPU Limit"
                    value={item?.limitByValue}
                />
                <TableInfoCard name="Amount" value={item?.amount} />
                <TableInfoCard name="VAT" value={item?.vatPercent} />

                <TableInfoCard
                    name="Status"
                    value={item?.status}
                    isCapitalize
                    className={`sm:hidden ${item?.status === 'active' ? '[&>.value-text]:text-success' : '[&>.value-text]:text-warning'}`}
                />
                <div className="flex flex-row gap-2 justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="Edit"
                        onClick={handleOpenModal}
                        className="h-7 min-w-14 text-sm"
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Delete"
                        onClick={(ev) => handleDelete(ev, item?.id)}
                        className="h-7 min-w-14 text-sm !bg-error"
                    />
                </div>
            </div>
        </div>
    );
}

function TableMobile({
    data,
    isDuration,
    isLifetime,
    handleDelete,
    openModal,
    filteredCurrencies,
    isPackageOrProductInactive
}) {
    return (
        <div className="product_pricing_list_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50 mb-4">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => (
                        <TableRow
                            key={item.id}
                            item={item}
                            isDuration={isDuration}
                            isLifetime={isLifetime}
                            handleDelete={handleDelete}
                            openModal={openModal}
                        />
                    ))
                )}
            </div>

            <div className="flex justify-end">
                <ButtonPrimary
                    title="Add +"
                    disabled={isPackageOrProductInactive || !filteredCurrencies?.length}
                    onClick={() => openModal('addPrice')}
                />
            </div>
        </div>
    );
}

export default TableMobile;
